import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import AssistantProvider from '@/contexts/AssistantContext';
import { AuthProvider } from '@/contexts/AuthContext';
import SnackbarProvider from '@/contexts/SnackbarContext';
import { InvyoThemeProvider } from '@/contexts/ThemeContext';
import { routes } from '@/routes/router';
import NotifierBridge from '@/store/notifier-bridge';
import { store } from '@/store/store';
import shellTheme from '@/theme';

// Built once at module scope: rebuilding it per render would reset the
// navigation state on every re-render of App.
const router = createBrowserRouter(routes);

/**
 * App: minimal orchestrator.
 * Only Providers, Router, and global layout belong here.
 */
export default function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={shellTheme}>
        <CssBaseline />
        <Sentry.ErrorBoundary fallback={<p>Une erreur inattendue est survenue.</p>}>
          <ReduxProvider store={store}>
            <InvyoThemeProvider>
              <SnackbarProvider>
                <NotifierBridge />
                <AuthProvider>
                  <AssistantProvider>
                    <RouterProvider router={router} />
                  </AssistantProvider>
                </AuthProvider>
              </SnackbarProvider>
            </InvyoThemeProvider>
          </ReduxProvider>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  );
}
